import React from "react";
import { Message } from "semantic-ui-react";
import BaseComponent from "./BaseComponent";

class ErrorDisplay extends BaseComponent {
  render() {
    return (
      <Message negative style={this.props.style}>
        {this.props.errorManager ? (
          this.props.errorManager
            .getErrors()
            .map((error) => <p key={error.index}>{error.description}</p>)
        ) : (
          <p>No Error Manager Available</p>
        )}
      </Message>
    );
  }
}

export default ErrorDisplay;
